import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import analyticsWrapper from 'components_library/utils/analyticsWrapper';
import s from './EtimesMobileTabs.scss';

const MobileTabs = props => {
  const { onChangeCallback, ga4Type, typeShemaClassNames, noLRPadding } = props;

  let { tabs } = props;
  if (!(Array.isArray(tabs) && tabs.length > 0)) return null;
  tabs = tabs.filter(item => item.name);

  const [selectedIndex, setSelectedIndex] = useState(0);
  const [l2selected, setL2Selected] = useState(false);

  const [itemNameSelected, setItemNameSelected] = useState();
  const [selectedL1Index, setSelectedL1Index] = useState(0);

  const listRef = useRef(null);

  let prevSelectedVal;

  const updateListData = (e, item, index, selected) => {
    e.stopPropagation();
    if (!selected) {
      let selectedIndexToRender = index;
      if (l2selected && index > 1) {
        selectedIndexToRender -= 1;
      }
      setSelectedIndex(index);
      onChangeCallback({ clickedItem: item });
      setSelectedL1Index(selectedIndexToRender);
      setL2Selected(false);
      setItemNameSelected(item.name);

      if (ga4Type) {
        analyticsWrapper('ga4', {
          event: 'user_click',
          type: ga4Type,
          category: 'tab_change',
          label: item.name,
        });
      }
    }
  };

  const setFocusToSelectedElement = () => {
    setTimeout(() => {
      if (listRef && listRef.current) {
        const selectedElem = listRef.current.getElementsByClassName(
          `${s.selected}`,
        );

        if (
          selectedElem &&
          Array.isArray(selectedElem) &&
          selectedElem.length &&
          selectedElem[0] &&
          prevSelectedVal !== selectedElem[0].innerText
        ) {
          const elem = selectedElem[0];
          prevSelectedVal = elem.innerText;
          const elemBoundary = elem.getBoundingClientRect();
          const elemEndPos = elemBoundary.left + elemBoundary.width;
          const windowWidth =
            window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth;
          if (elemEndPos > windowWidth) {
            listRef.current.scrollLeft += elemEndPos - windowWidth;
          } else if (elemBoundary.left < 0) {
            listRef.current.scrollLeft += elemBoundary.left;
          }
        }
      }
    }, 0);
  };

  useEffect(
    () => {
      if (l2selected && !itemNameSelected) {
        setFocusToSelectedElement();
      }
    },
    [selectedIndex, l2selected, itemNameSelected],
  );

  let l1List = [];

  let selectedL1IndexToRender = selectedL1Index;

  const itemsInL1 = tabs.length;
  l1List = tabs.slice(0, itemsInL1);
  if (l1List.length > 0 && selectedIndex > l1List.length - 1 && l2selected) {
    l1List.splice(1, 0, tabs[selectedIndex]);
    selectedL1IndexToRender = 1;
    l1List = l1List.slice(0, itemsInL1);
  } else if (l2selected) {
    selectedL1IndexToRender = selectedIndex;
  }

  return (
    <>
      {/* <Header {...props.header} ga={ga}>
          {showDropdown && (
            <div className={s.change} onClick={openListingDropDown}>
              <span>
                <i />
                <i />
                <i />
              </span>
            </div>
          )}
        </Header> */}
      {l1List &&
        Array.isArray(l1List) &&
        l1List.length > 0 && (
          <ul
            className={`${s.SubNav} ${
              noLRPadding ? s.noLRPadding : ''
            } ${typeShemaClassNames}`}
            ref={listRef}
          >
            {l1List.map((item, index) => (
              <li
                key={index}
                className={`${
                  index === selectedL1IndexToRender ? s.selected : ''
                }`}
                onClick={e =>
                  updateListData(
                    e,
                    item,
                    index,
                    index === selectedL1IndexToRender,
                  )
                }
              >
                {item.name}
              </li>
            ))}
          </ul>
        )}
    </>
  );
};

MobileTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string.isRequired,
      link: PropTypes.string,
      active: PropTypes.bool,
    }),
  ),
  header: PropTypes.shape({}),
  onChangeCallback: PropTypes.func,
  ga4Type: PropTypes.string,
};

MobileTabs.defaultProps = {
  tabs: undefined,
  header: undefined,
  onChangeCallback: undefined,
  ga4Type: '',
};

export default MobileTabs;
